import changeShipping from './changeShipping';
import invalidateMagentoCache from './invalidateMagentoCache';

const StorePlugins = [
    changeShipping,
    invalidateMagentoCache,
];

export default StorePlugins;
